<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="chapter-1">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-with-element-number">
<div class="element-number-block">
<div class="element-number case-upper"></div>
</div>
<div class="title-block">
<h1 class="element-title case-upper">THE KAI SWEET POTATO PIE</h1>
</div>
<div class="heading-ornament-block heading-ornament-aspect-wide">
<div class="heading-ornament-size-container">
<img alt="" class="heading-ornament-image" src="images/heading-swash-ornate-screen.png"/>
</div>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-1-text">
<p class="first first-in-chapter first-full-width first-with-first-letter-f"><span class="drop-cap">f</span>rom USA TODAY Bestselling Author Naleighna Kai</p>
<div class="inline-image inline-image-kind-photograph inline-image-size-medium inline-image-flow-center inline-image-flow-within-text inline-image-aspect-tall block-height-not-mult-of-line-height inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end">
<div class="inline-image-container">
<img alt="" src="images/image-46747949_10156249323674633_3709105779408633856_n.jpg"/>
</div>
</div>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">Mine differs</span> in the fact that I don’t use milk or white sugar. I use egg nog and the rum cream or Irish cream instead; and brown sugar instead of white sugar.</p>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">1 (1 pound)</span> sweet potato</p>
<p class="subsq">3/4 cup butter, softened</p>
<p class="subsq">1 1/4 cup brown sugar</p>
<p class="subsq">1/2 cup egg nog (preferably Oberweis or CF Burger – it’s thicker and richer) AND 1/4 cup rum cream or Bailey’s Irish cream</p>
<p class="subsq">2 eggs</p>
<p class="subsq">1 teaspoon ground nutmeg</p>
<p class="subsq">1/2 teaspoon ground cinnamon</p>
<p class="subsq">1 teaspoon vanilla extract</p>
<p class="subsq">1 (9 inch) unbaked pie crust (preferably one WITHOUT lard or animal shortening).</p>
<p class="implicit-break"></p>
<p class="first first-in-section first-full-width"><span class="first-phrase">Boil sweet</span> potato whole in skin for 40 to 50 minutes, or until done. Run cold water over the sweet potato, and remove the skin.</p>
<p class="subsq">Break apart sweet potato in a bowl. Add butter, and mix well with mixer. Stir in sugar, milk, eggs, nutmeg, cinnamon, and vanilla. Beat on medium speed until mixture is smooth. Pour filling into an unbaked pie crust.</p>
<p class="subsq">Bake at 350 degrees F (175 degrees C) for 55 to 60 minutes, or until knife inserted in center comes out clean. Pie will puff up like a soufflé, and then will sink down as it cools.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter001.vue?5a1d84ce